import styled from "styled-components"

const Badge = styled.span<{ $variant: "high" | "medium" | "low" }>`
  display: inline-block;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid;

  ${({ $variant }) => {
    switch ($variant) {
      case "high":
        return `
          color: #ef4444;
          border-color: #fca5a5;
          background-color: #fee2e2;
        `
      case "medium":
        return `
          color: #f59e0b;
          border-color: #fcd34d;
          background-color: #fef3c7;
        `
      case "low":
        return `
          color: #22c55e;
          border-color: #86efac;
          background-color: #dcfce7;
        `
    }
  }}
`

export type PriorityBadgeVariant = "high" | "medium" | "low"

interface Props {
  variant: PriorityBadgeVariant
  children: React.ReactNode
}

export const PriorityBadge = ({ variant, children }: Props) => <Badge $variant={variant}>{children}</Badge>
